import React from "react";
import "./fielderror.css";
import ErrorIcon from "../../assets/images/Error.svg";
import InfoIcon from "../../assets/images/info_small.svg";

const FieldError = ({ error, info, id = "", InfoStyle = {} }) => {
  if (!error && !info) return null;

  if (error)
    return (
      <p className="error-text" id={id}>
        <img
          src={ErrorIcon}
          alt="Error"
          style={{
            color: "#C70000",
            width: "24px",
            height: "24px",
            verticalAlign: "middle",
          }}
        />
        {error?.message}
      </p>
    );

  if (info)
    return (
      <p
        className="info-text"
        style={{ ...InfoStyle }}
        dangerouslySetInnerHTML={{
          __html: `<img src="${InfoIcon}" alt="" style="width: 20px; height: 20px; margin-right: 8px; vertical-align: middle;" /><span>${info}</span>`,
        }}
      />
    );
};

export default FieldError;
